module.exports = __webpack_public_path__ + "static/media/52.e57fbdfa.png";